import toast from "react-hot-toast";

export const ErrorAlertWithTranslation = ({ code, translation }) => {
  let message = translation(code, { ns: "validation" });
  return toast.error(message ?? "An error occurred. Please try again.");
};

export const SuccessAlertWithTranslation = ({ code, translation }) => {
  let message = translation(code, { ns: "validation" });
  return toast.success(message ?? "An error occurred. Please try again.");
};
